module.exports = __webpack_public_path__ + "img/delivery_white.76b9ba33.svg";